import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  private subjectPerms: Map<number, string[]> = new Map();
  
  constructor() {}

  hasAnyUserPerm(reqdPerms: string[]): boolean {
    const account: string[] = JSON.parse(atob(localStorage.getItem('account')!));
    if (!reqdPerms || reqdPerms.length === 0) {
      return true;
    }
    if (account != null) {
      return account.some(item => reqdPerms.includes(item));
    }
    return false;
  }

  hasUserPerm(reqdPerm: string): boolean {
    const account = JSON.parse(atob(localStorage.getItem('account')!));
    if (!reqdPerm) {
      return true;
    }
    if (account != null) {
      return account.includes(reqdPerm);
    }
    return false;
  }

  getSubjPerms(subjectId: number): string[] | undefined {
    return this.subjectPerms.get(Number(subjectId))?.slice();
  }
  
  setSubjPerms(subjectId: number, perms: string[]) {
    this.subjectPerms.set(Number(subjectId), perms);
  }
  
  clearSubjPerms(subjectId?: number) {
    if (subjectId === undefined) {
      this.subjectPerms = new Map();
    } else {
      this.subjectPerms.delete(Number(subjectId));
    }
  }
  
  hasAnySubjPerm(subjectId: number, perms: string[]): boolean {
    if (!subjectId || this.getSubjPerms(subjectId) === undefined) {
      return false;
    }
    if (!perms || perms.length === 0 ) {
      return true;
    }
    return this.getSubjPerms(subjectId)!.some(item => perms.includes(item));
  }

  hasSubjPerm(subjectId: number, perm: string): boolean {
	if (!subjectId || this.getSubjPerms(subjectId) === undefined) {
      return false;
    }
    if (!perm) {
      return true;
    }
    return this.getSubjPerms(subjectId)!.includes(perm);
  }

}
